class ReiandoMainCollection {
  constructor(section) {
    this.section = section;

    this.filterButton = section.querySelector(
      '[data-reiando-filter-toggle]'
    );
    this.filterPanel = section.querySelector(
      '[data-reiando-filter-panel]'
    );

    this.sortButton = section.querySelector(
      '[data-reiando-sort-toggle]'
    );
    this.sortPanel = section.querySelector(
      '[data-reiando-sort-panel]'
    );

    this.sortForm = section.querySelector(
      '[data-reiando-sort-form]'
    );
    this.sortInputs = Array.from(
      section.querySelectorAll('[data-reiando-sort-input]')
    );

    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.handleSortClick = this.handleSortClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    if (this.filterButton && this.filterPanel) {
      this.filterButton.addEventListener(
        'click',
        this.handleFilterClick
      );
    }

    if (this.sortButton && this.sortPanel) {
      this.sortButton.addEventListener(
        'click',
        this.handleSortClick
      );
    }

    this.sortInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!this.sortForm) return;

        this.sortForm.submit();
      });
    });

    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  handleFilterClick() {
    const willOpen =
      this.filterButton.getAttribute('aria-expanded') !== 'true';

    this.closeSort();
    this.setPanelState(
      this.filterButton,
      this.filterPanel,
      willOpen
    );
  }

  handleSortClick() {
    const willOpen =
      this.sortButton.getAttribute('aria-expanded') !== 'true';

    this.closeFilter();
    this.setPanelState(
      this.sortButton,
      this.sortPanel,
      willOpen
    );
  }

  handleDocumentClick(event) {
    if (this.section.contains(event.target)) return;

    this.closeAll();
  }

  handleKeydown(event) {
    if (event.key !== 'Escape') return;

    const filterIsOpen =
      this.filterButton?.getAttribute('aria-expanded') === 'true';

    const sortIsOpen =
      this.sortButton?.getAttribute('aria-expanded') === 'true';

    if (filterIsOpen) {
      this.closeFilter();
      this.filterButton.focus();
    }

    if (sortIsOpen) {
      this.closeSort();
      this.sortButton.focus();
    }
  }

  setPanelState(button, panel, isOpen) {
    if (!button || !panel) return;

    button.setAttribute(
      'aria-expanded',
      isOpen ? 'true' : 'false'
    );

    panel.hidden = !isOpen;

    if (isOpen) {
      panel.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }

  closeFilter() {
    this.setPanelState(
      this.filterButton,
      this.filterPanel,
      false
    );
  }

  closeSort() {
    this.setPanelState(
      this.sortButton,
      this.sortPanel,
      false
    );
  }

  closeAll() {
    this.closeFilter();
    this.closeSort();
  }

  destroy() {
    if (this.filterButton) {
      this.filterButton.removeEventListener(
        'click',
        this.handleFilterClick
      );
    }

    if (this.sortButton) {
      this.sortButton.removeEventListener(
        'click',
        this.handleSortClick
      );
    }

    document.removeEventListener(
      'click',
      this.handleDocumentClick
    );

    document.removeEventListener(
      'keydown',
      this.handleKeydown
    );
  }
}

function initializeReiandoMainCollection(root = document) {
  root
    .querySelectorAll('[data-reiando-products]')
    .forEach((section) => {
      if (
        section.dataset.reiandoCollectionInitialized === 'true'
      ) {
        return;
      }

      section.dataset.reiandoCollectionInitialized = 'true';

      section.reiandoMainCollection =
        new ReiandoMainCollection(section);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeReiandoMainCollection();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeReiandoMainCollection(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector(
    '[data-reiando-products]'
  );

  if (!section?.reiandoMainCollection) return;

  section.reiandoMainCollection.destroy();
});